export const CAST_ROLE: number = 3;
export const USER_ROLE: number = 2;
export const ADMIN_ROLE: number = 1;
